// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"5f19b596","667":"b85bee63","977":"48858afe"}[chunkId] + ".chunk.js";
};